export const firebaseConfig = {
  apiKey: "AIzaSyBhJl489GZQB30PNVkCd9SA5QpsYBUbrZc",
  authDomain: "gowaterfall-dev.firebaseapp.com",
  databaseURL: "https://gowaterfall-dev.firebaseio.com",
  projectId: "gowaterfall-dev",
  storageBucket: "gowaterfall-dev.appspot.com",
  messagingSenderId: "252330681907",
  appId: "1:252330681907:web:a5d4127019cf3429902546",
  measurementId: "G-BS2M77B2MS"
};